import React, { useEffect } from "react";
import { useState, useContext } from "react";
import * as request from "superagent";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import LoadingView from "~common/components/loading-view";
import DefinitionSection from "~common/form/definition-section-fc";
import {
  DataContext,
  PolicyContext,
  //   DirtyContext,
} from "~common/form/icg-definition-data-provider";
// import { cloneDeep } from "lodash";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonBar: {
      display: "flex",
      justifyContent: "flex-end",
      spaceBetween: 15,
      padding: 15,
    },
    buttonArea: {
      marginTop: 15,
      justifyContent: "flex-end",
      minHeight: 50,
    },
    button: {
      marginLeft: 15,
    },
  })
);

interface ActionProps {
  label: any;
  onClick?: Function;
  submit?: boolean;
  variant?: any;
  color?: any;
}

interface Props {
  definition: any;
  actions: Array<ActionProps>;
  data?: any;
  formUrl?: string;
  policyMessages?: Array<any>;
  errorText?: string;
  gridSpacing?: any;
}

export const ActionForm: React.FC<Props> = ({
  definition,
  actions,
  data,
  formUrl,
  policyMessages,
  errorText,
  gridSpacing,
}) => {
  const [fullData, setFullData] = useContext(DataContext);

  const classes = useStyles();

  useEffect(() => {
    if (data) {
        setFullData(data)
    }
  }, [])

  const handleActionClick = (action:any) => (event: any) => {
    console.log("Showing fullData", fullData);
    action.onClick(fullData, null)
  };

  const renderActionButtons = () => {
    return (
      <div className={classes.buttonBar}>
        <div className={classes.buttonArea}>
          {actions.map((a: ActionProps, idx: number) => {
            return (
              <Button
                key={idx}
                variant="contained"
                color={a.color || "inherit"}
                className={classes.button}
                onClick={handleActionClick(a)}
              >
                {a.label}
              </Button>
            );
          })}
        </div>
      </div>
    );
  };
  
  console.log(definition.title)
  return (
    <React.Fragment>
      <DefinitionSection
        definition={definition}
        path={""}
        gridSpacing={gridSpacing || 5}
        suppressTitle
      />
      {renderActionButtons()}
    </React.Fragment>
  );
};

export default ActionForm;
